import React from 'react';
import { FormContext } from 'react-hook-form';
import { TextInput as RNTextInput } from 'react-native';
import { Subheading } from 'react-native-paper';
import { t, Trans } from '@lingui/macro';

import AuthenticationContainer from '@src/components/AuthenticationContainer';
import AuthenticationScrollView from '@src/components/AuthenticationScrollView';
import AuthenticationSendButton from '@src/components/AuthenticationSendButton';
import KeyboardAvoidingView from '@src/components/KeyboardAvoidingView';
import TextInput from '@src/components/TextInput';
import VisibleStatusBar from '@src/components/VisibleStatusBar';
import { i18n } from '@src/i18n';

import { Wrapper } from './styled';
import { Props } from './types';
import useForm from './useForm';

const Screen: React.FC<Props> = () => {
  const { form, handleSubmit, loading } = useForm();
  const ref = React.useRef<RNTextInput>();

  const handleFocusNextInput = React.useCallback(() => {
    ref.current?.focus();
  }, []);

  return (
    <>
      <VisibleStatusBar />
      <AuthenticationContainer>
        <AuthenticationScrollView>
          <KeyboardAvoidingView style={{ justifyContent: 'space-between' }}>
            <FormContext {...form}>
              <Wrapper>
                <Subheading style={{ marginBottom: 20 }}>
                  <Trans>Enter your new password</Trans>
                </Subheading>
                <TextInput
                  name="password"
                  label={i18n._(t`Password`)}
                  returnKeyType="next"
                  textContentType="newPassword"
                  onSubmitEditing={handleFocusNextInput}
                  secureTextEntry
                  disabled={loading}
                />
                <TextInput
                  //@ts-ignore
                  ref={ref}
                  name="retypePassword"
                  label={i18n._(t`Retype Password`)}
                  textContentType="newPassword"
                  returnKeyType="go"
                  onSubmitEditing={handleSubmit}
                  secureTextEntry
                  disabled={loading}
                />
              </Wrapper>
              <AuthenticationSendButton
                loading={loading}
                disabled={loading}
                onPress={handleSubmit}
              >
                <Trans>Submit</Trans>
              </AuthenticationSendButton>
            </FormContext>
          </KeyboardAvoidingView>
        </AuthenticationScrollView>
      </AuthenticationContainer>
    </>
  );
};

Screen.displayName = 'ResetPassword';

export default Screen;
